import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { organizationJobfeedAutoCompleteInput$, organizationJobfeedAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';
import access from 'constants/access';

const OrganizationJobfeedAutoSuggest = renderAutoSuggestWithOptions(
   organizationJobfeedAutoCompleteObservable$,
   organizationJobfeedAutoCompleteInput$,
   undefined,
   undefined,
   undefined,
   access.byRole.employer.onlyAdmin,
);

OrganizationJobfeedAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Organization...',
};

export default OrganizationJobfeedAutoSuggest;
